


import React from 'react';
import { Versioning } from 'amazon-chime-sdk-component-library-react';
import { Versioning as SDKVersioning } from 'amazon-chime-sdk-js';

export const VersionLabel = () => {
  const versionTag = `${Versioning.sdkName}@${Versioning.sdkVersion}`;
  const sdkVersionTag = `${SDKVersioning.sdkName}@${SDKVersioning.sdkVersion}`;

  return (
    <span
      style={{
        position: 'absolute',
        bottom: 1,
        right: 1,
        color: '#989da5',
        fontSize: '0.70rem'
      }}
    >
      {versionTag} | {sdkVersionTag}
    </span>
  );
};
